import React, {Component} from 'react';
import {authService} from "../../../auth";
import {connect} from "react-redux";
import {Scrollbars} from 'react-custom-scrollbars';

class UnAuthSkillsPopUp extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage()
        }
    }

    render() {
        return (
            <div id="unauthprofSkillsViewpop" className="modal fade dgpopup reqendorse" data-backdrop="static"
                 data-keyboard="false">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="profcolwidget">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>
                                <div className="profcolwidgetdesc">
                                    <h4>Skills</h4>
                                    <Scrollbars
                                        className={'profcolwidgetwrap'}
                                        autoHide
                                        autoHeight
                                        autoHeightMin={0}
                                        autoHeightMax={325}
                                        universal={true}
                                        renderTrackHorizontal={props => <div {...props} className="track-horizontal"/>}
                                        renderTrackVertical={props => <div {...props} className="track-vertical"/>}
                                    >
                                        <div className="tags">
                                            {this.props.skills &&
                                            this.props.skills.map((item, index) => {
                                                return <span key={index}>{item}</span>;
                                            })
                                            }
                                        </div>
                                    </Scrollbars>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




export default UnAuthSkillsPopUp;

